/**
 * DetailEvent section.
 */
import Container from '@components/atoms/container/detailEventContainer';
import Context from '@shared/components/utils/context/detailContext';
import Hero from '@components/elements/detail/detailHero';
import Info from '@components/elements/detail/detailInfo';
import Synopsis from '@components/elements/detail/detailSynopsis';
import Tip from '@components/elements/detail/detailTip';
import Title from '@components/atoms/text/detailEventTitle';
import { useContext } from 'react';

/**
 * Displays the detail event section.
 * Displays buttons, channel logo, accessibility, and poster.
 */
export default function DetailEvent() {
  const { metadata } = useContext(Context);
  const title = metadata?.eventTitle || '';
  return (
    <Container id='detailEvent'>
      <Hero />
      <Tip />
      <Title>{title}</Title>
      <Info />
      <Synopsis />
    </Container>
  );
}
